import type { DocumentData, QueryConstraint } from "firebase/firestore";
import { limit, where } from "firebase/firestore";
import { firestoreApi } from "../core/apis/firestoreApi";
import BaseApi from "../core/BaseApi";
import { log } from "../ui/log";
import PlansTemplateModel, {
  type PlansTemplateModelData,
} from "./PlansTemplateModel";

export default class PlansTemplateApi extends BaseApi<
  PlansTemplateModel,
  PlansTemplateModelData
> {
  /* PRIVATE APIS */

  /* NEEDED BASE API OVERRIDES */

  async getByEditHash(hash: string) {
    try {
      log.network("Get by hash ID from", this.db, "hash", hash);

      const qs: QueryConstraint[] = [where("editHash", "==", hash), limit(1)];

      const docSnaps = await firestoreApi.queryDocuments(this.db, ...qs);

      const docSnap = docSnaps[0];

      if (docSnap) {
        const itemModel = this.fromFirestore(docSnap);

        this.store.load([itemModel]);
        return itemModel;
      }

      return;
    } catch (e: unknown) {
      log.error("Got getByEditHash error", e);

      if (e instanceof Error) {
        const errorWithMessage = new Error(
          `${e.message} -  Get by hash from ${this.db}, uid: ${hash}`,
        );
        errorWithMessage.name = e.name;
        errorWithMessage.stack = e.stack;

        this.stores.devsStore.setGotError(errorWithMessage);
      }
    }
  }

  get db() {
    return `${this.dbPrefix}templates`;
  }

  get store() {
    return this.stores.templatesStore;
  }

  fromFirestore(res: DocumentData): PlansTemplateModel {
    return new PlansTemplateModel(this.stores, this.api, {
      uid: res.id,
      ...res.data(),
    });
  }
}
